import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const EyeFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M21.48 11.52c-.25-.55-.55-1.08-.88-1.58-1.89-2.85-5.04-4.72-8.6-4.72-3.56 0-6.71 1.87-8.6 4.72-.33.5-.63 1.03-.88 1.58-.11.25-.11.55 0 .8.25.55.55 1.08.88 1.58 1.89 2.85 5.04 4.72 8.6 4.72 3.56 0 6.71-1.87 8.6-4.72.33-.5.63-1.03.88-1.58.11-.25.11-.55 0-.8ZM12 16.25c-2.35 0-4.25-1.91-4.25-4.25A4.26 4.26 0 0 1 12 7.75 4.26 4.26 0 0 1 16.25 12 4.26 4.26 0 0 1 12 16.25Z"
        fill={color}
      />
      <Path
        d="M12 14.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EyeFilled
